import { Button, Modal } from "react-bootstrap";
import { testHandlePrintAsPDF } from "../../utils/pdfhandler";
import CertificatePreview from "../../components/Certificate/Preview";
import CertificateOutput from "../../components/Certificate/Output";
import { useRef, useState } from "react";

export default function CertificateModal({
  showModal,
  setShowModal,
  name,
  data
}) {
  const cardRef = useRef(null), pdfRef = useRef(null);
  const [downloading, setDownloading] = useState(false);
  return (
    <>
      <div style={styles.overlay}>
        <div style={styles.modal}>
          <div style={styles.header}>
            <span style={styles.title}>Certificate Preview</span>
            <button style={styles.closeBtn} onClick={() => setShowModal(false)}>
              &times;
            </button>
          </div>
          <div style={styles.body}>
            {/* <div
              ref={cardRef}
              style={{
                background: "url('img/kiyg-esports-template.jpg') no-repeat",
                backgroundSize: "contain", // Ensures the whole image fits
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                // width: "100%", // full width of the modal
                // width: "400px", // never wider than 400px
                // aspectRatio: "400 / 310", // maintains 400:310 ratio (width:height)
                // minHeight: "400px",
                // minHeight: "400px",
                overflow: "auto",
                // backgroundColor: "yellow",
                // height: "400px",
                // height: "310px",
                // height: "434px",
                height: "1240px",
                // height: "2480px",
                // minHeight: "256px",
                // width: "100%",
                // width: "560px",
                width: "1600px",
                // width: "3198px",
                // width: "400px",
                // minWidth: "550px",
                // aspectRatio: "400 / 310", // maintains 400:310 ratio (width:height)
                // padding: "40px",
                // textAlign: "center",
                borderRadius: "16px",
                color: "#333",
                fontFamily: "serif",
                position: "relative",
              }}
            >
              <h4
                style={{
                  position: "absolute",
                  // top: "52%",
                  top: "50%",
                  left: "50%",
                  // top: "218px",
                  // left: "280px",
                  transform: "translate(-50%, -50%)",
                  fontSize: "17px",
                  fontWeight: "bold",
                }}
              >
                {data?.name || name}
              </h4>
              <h6
                style={{
                  position: "absolute",
                  textAlign: "center",
                  // top: "61.5%",
                  top: "60.3%",
                  // top: "262px",
                  left: "62%",
                  // left: "347px",
                  transform: "translate(0, -50%)",
                  fontSize: "9px",
                  fontWeight: "bold",
                }}
              >
                {data?.title||"Battlegrounds Mobile India"}
              </h6>
              <h6
                style={{
                  position: "absolute",
                  textAlign: "center",
                  // top: "27.5%",
                  top: "26.3%",
                  left: "12%",
                  transform: "translate(0, -50%)",
                  fontSize: "8.2px",
                  fontWeight: "bold",
                }}
              >
                {data?.referenceNo||"KIYG25/ES/001"}
              </h6>
            </div> */}
            <CertificatePreview previewRef={cardRef} name={name} data={data}/>
            {/* output hidden from user */}
            <CertificateOutput pdfRef={pdfRef} name={name} data={data}/>
          </div>
          <div style={styles.footer}>
            <button style={styles.button} onClick={() => setShowModal(false)}>
              Close
            </button>
            <button
              style={{
                ...styles.button,
                opacity: downloading ? 0.7 : 1,
                pointerEvents: downloading ? "none" : "auto",
              }}
              disabled={downloading}
              onClick={async () => {
                if (downloading) return;
                setDownloading(true);
                try {
                  await testHandlePrintAsPDF(pdfRef, name);
                } finally {
                  setDownloading(false);
                }
              }}
            >
              {downloading ? "Downloading..." : "Download"}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    overflow: "auto",
    // overflow: "hidden",
    // aspectRatio: "16 / 9",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(0,0,0,0.5)",
    zIndex: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modal: {
    background: "#fff",
    borderRadius: "10px",
    // width: "600px",
    maxWidth: "95vw",
    boxShadow: "0 2px 8px rgba(0,0,0,0.3)",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    padding: "16px",
    borderBottom: "1px solid #eee",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  title: {
    fontWeight: "bold",
    fontSize: "1.2rem",
  },
  closeBtn: {
    background: "none",
    border: "none",
    fontSize: "2.5rem",
    cursor: "pointer",
    lineHeight: 1,
  },
  body: {
    // padding: "16px",
    overflow: "auto",
  },
  footer: {
    padding: "16px",
    borderTop: "1px solid #eee",
    textAlign: "right",
  },
  button: {
    padding: "8px 20px",
    margin: "1px",
    borderRadius: "5px",
    border: "none",
    background: "#007bff",
    color: "#fff",
    cursor: "pointer",
    fontSize: "1rem",
  },
};
